/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Docsmodal_Description3Inputs */

const en_settings_reportingapikeys_docsmodal_description3 = /** @type {(inputs: Settings_Reportingapikeys_Docsmodal_Description3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the documentation link and its read-only credentials with the client, through separate channels from the API key itself.`)
};

/**
* | output |
* | --- |
* | "Share the documentation link and its read-only credentials with the client, through separate channels from the API key itself." |
*
* @param {Settings_Reportingapikeys_Docsmodal_Description3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_docsmodal_description3 = /** @type {((inputs?: Settings_Reportingapikeys_Docsmodal_Description3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Docsmodal_Description3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_docsmodal_description3(inputs)
});
export { settings_reportingapikeys_docsmodal_description3 as "settings_reportingApiKeys_docsModal_description" }